import { userFilterCategories } from "../../../shared/lookup";
import SystemHelper from "../../../shared/systemHelper";
const workflows = [
    {
        id: 52,
        title: 'Cost Forecast',
        notificationName: 'Cost Forecast',
        abbreviation: '$SUPPLIER_ABBREVIATION-CostForecast-',
        notifyingParty: 'SUPPLIER',
        notify: true,
        assetFieldsEnabled: false,

        form_IncludeCompanyName: false,
        form_CompanyName: 'PARTY',
        form_CompanyLogo: 'PARTY',

        notifyAttachments: true,

        includePdfjson: false,

        config: {
            description: 'Supplier Cost Forecast',
            currentModel: 'Forecast',
            currentModelType: 'CostForecast',
            referenceType: 'Forecast',
            documentType: 'DocumentCostForecast',


            showInRelations: true,
            showInCustomFields: true,
            notifyPossible: true,
            replyPossible: false,
            configurableAssets: true,

            userFilterCategories: [
                userFilterCategories.ACCESS,
                userFilterCategories.MAIN_NOTICE,
                userFilterCategories.NOTIFY
            ],
            paths: {
                base: 'cost',
                create: 'create',
                list: 'list',
                default: 'list'
            },
            enabled: SystemHelper.getSettingValueBoolean.bind(SystemHelper, SystemHelper.SETTINGS.FORECASTS_ENABLED)
        }
    },
    {
        id: 53,
        title: 'Carbon Forecast',
        notificationName: 'Carbon Forecast',
        abbreviation: '$SUPPLIER_ABBREVIATION-CarbonForecast-',
        notifyingParty: 'SUPPLIER',
        notify: true,
        assetFieldsEnabled: false,

        form_IncludeCompanyName: false,
        form_CompanyName: 'PARTY',
        form_CompanyLogo: 'PARTY',

        notifyAttachments: true,

        includePdfjson: false,

        config: {
            description: 'Supplier Carbon Forecast',
            currentModel: 'Forecast',
            currentModelType: 'CarbonForecast',
            referenceType: 'Forecast',
            documentType: 'DocumentCarbonForecast',


            showInRelations: true,
            showInCustomFields: true,
            notifyPossible: true,
            replyPossible: false,
            configurableAssets: true,

            userFilterCategories: [
                userFilterCategories.ACCESS,
                userFilterCategories.MAIN_NOTICE,
                userFilterCategories.NOTIFY
            ],
            paths: {
                base: 'carbon',
                create: 'create',
                list: 'list',
                default: 'list'
            },
            enabled: SystemHelper.getSettingValueBoolean.bind(SystemHelper, SystemHelper.SETTINGS.FORECASTS_ENABLED)
        }
    },
    {
        id: 87,
        title: 'Batch Cost Forecasts',
        notificationName: 'Batch Cost Forecast',
        abbreviation: 'COSTFORECAST-BATCH-',
        notifyingParty: 'SUPPLIER',
        notify: true,
        //assetFieldsEnabled: false,

        form_IncludeCompanyName: false,
        form_CompanyName: 'PARTY',
        form_CompanyLogo: 'PARTY',

        //notifyAttachments: true,

        includePdfjson: false,

        config: {
            description: 'Batch Cost Forecasts',
            currentModel: 'CostForecastBatch',
            currentModelType: 'CostForecast',
            referenceType: 'CostForecastBatch',
            documentType: 'DocumentCostForecast',

            showInRelations: true,
            showInCustomFields: false,
            notifyPossible: true,
            replyPossible: false,
            //configurableAssets: true,

            userFilterCategories: [
                userFilterCategories.ACCESS,
                userFilterCategories.MAIN_NOTICE,
                userFilterCategories.NOTIFY
            ],
            paths: {
                base: 'cost-batch',
                create: 'list#wizard',
                list: 'list',
                default: 'list'
            },
            enabled: () => (process.env.REACT_APP_COSTFORECAST_BATCH_ENABLED === "true")
        }
    }
]

export default workflows;